import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import IconJpg from '../../assets/new-icons/jpg-min.png';
import IconPdf from '../../assets/new-icons/pdf-min.png';
import IconId from '../../assets/new-icons/icon-id-min.svg';
import IconIdReverse from '../../assets/new-icons/icon-id-reverse-min.svg';
import { useSelector } from 'react-redux';

function AllowFormatsModal({
  showModal,
  handleConfirmAttachment = () => {},
  handleHideFormatsModal = () => {},
}) {
  const {
    imageFront,
  } = useSelector((state) => state.ocr);
  const location = useLocation();
  const { t } = useTranslation();

  console.log({ imageFront })
  const handleClose = () => {
    console.log(location);
    handleHideFormatsModal();
  };

  const confirmAttachment = () => {
    handleConfirmAttachment();
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      contentClassName="border-0"
      centered
    >
      <Modal.Header className="pt-3 pb-0 border-0" closeButton>
        <Modal.Title className="mx-auto text-center">
          <img src={IconJpg} alt="icon-warning" className="pb-3" style={{ width: '59px' }} />
          <img src={IconPdf} alt="icon-warning" className="pb-3" style={{ width: '55px' }} />
          {/* <p className="mb-0 app-txt-red">{t('TXT_TITLE_WARNING')}</p> */}
          <p className="mb-0 app-fw-notosans-bold app-txt-granite">{t('TXT_TITLE_ALLOW_FORMATS')}</p>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0 app-txt-granite-80-dark text-center app-fs-15 app-lh-h4">
          {t('TXT_DESCRIPTION_ALLOW_FORMATS')}
          <span className="app-fw-notosans-bold">
            {' '}
            {t('TXT_ALLOW_FORMATS')}
          </span>
        </p>
        <div className="">
          <hr className="app-txt-gold" />
        </div>
        <div className="text-center">
          <p className="mb- app-txt-granite-80-dark text-center app-fs-15 app-lh-h4 text-uppercase">
            <span className="app-fw-notosans-bold">
              {t(`TXT_${imageFront === '' ? 'FRONT' : 'REVERSE'}_DOCUMENT`)}
              {' '}
            </span>
            {t('TXT_FROM_DOCUMENT')}
          </p>
          <img
            src={imageFront === '' ? IconId : IconIdReverse}
            alt={imageFront === '' ? 'IconId' : 'IconIdReverse'}
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="border-0 mx-auto">
        <Button
          variant=""
          onClick={confirmAttachment}
          className="app-bg-sand app-fw-notosans-bold app-txt-granite w-100 rounded-3 btn-height px-4"
        >
          {t('TXT_BUTTON_SELECT_FILE')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default AllowFormatsModal;
